import {
  GENERIC_ERROR_MESSAGE,
  GENERIC_ERROR_TITLE,
  REQUEST_CHANGE_PASSWORD_SUCCESS_MESSAGE,
  REQUEST_SUCCESS_TITLE,
  SERVER_ERROR_MESSAGE,
  SERVER_ERROR_TITLE,
  RECOVERY_RESENT_MESSAGE,
  RESEND_RATE_LIMITED_TITLE,
  RESEND_RATE_LIMITED_MESSAGE,
} from "@/constants/messages";

export const TOAST_MESSAGES = {
  GENERIC_ERROR: {
    title: GENERIC_ERROR_TITLE,
    description: GENERIC_ERROR_MESSAGE,
  },
  SUCCESS: {
    title: REQUEST_SUCCESS_TITLE,
    description: REQUEST_CHANGE_PASSWORD_SUCCESS_MESSAGE,
  },
  SERVER_ERROR: {
    title: SERVER_ERROR_TITLE,
    description: SERVER_ERROR_MESSAGE,
  },
  RESEND_SUCCESS: {
    title: REQUEST_SUCCESS_TITLE,
    description: RECOVERY_RESENT_MESSAGE,
  },
  OVER_EMAIL_SEND_RATE_LIMIT: {
    title: RESEND_RATE_LIMITED_TITLE,
    description: RESEND_RATE_LIMITED_MESSAGE,
  },
};
